import { useEffect, useState } from "react";
import NavBar from "../navBar";

function AccountPageShell({ children, className = "" }) {
  const [isDesktop, setIsDesktop] = useState(
    () => typeof window !== "undefined" && window.innerWidth >= 1024
  );
  const [isCollapsed, setIsCollapsed] = useState(
    () => typeof window !== "undefined" && window.localStorage.getItem("desac-sidebar-collapsed") === "true"
  );
  const [isAuthenticated, setIsAuthenticated] = useState(
    () => typeof window !== "undefined" && window.localStorage.getItem("token") !== null
  );

  useEffect(() => {
    const updateViewport = () => {
      setIsDesktop(window.innerWidth >= 1024);
      setIsCollapsed(window.localStorage.getItem("desac-sidebar-collapsed") === "true");
      setIsAuthenticated(window.localStorage.getItem("token") !== null);
    };
    const updateCollapsedState = (event) => {
      setIsCollapsed(
        typeof event?.detail?.collapsed === "boolean"
          ? event.detail.collapsed
          : window.localStorage.getItem("desac-sidebar-collapsed") === "true"
      );
    };
    window.addEventListener("resize", updateViewport);
    window.addEventListener("storage", updateCollapsedState);
    window.addEventListener("desac-sidebar-toggle", updateCollapsedState);
    return () => {
      window.removeEventListener("resize", updateViewport);
      window.removeEventListener("storage", updateCollapsedState);
      window.removeEventListener("desac-sidebar-toggle", updateCollapsedState);
    };
  }, []);

  const sidebarWidth = isDesktop && isCollapsed ? "5rem" : "16rem";

  return (
    <>
      <NavBar />
      <main
        style={{ "--account-sidebar-width": sidebarWidth }}
        className={`min-h-screen min-w-0 overflow-x-hidden bg-surface-950 pt-16 text-white ${isAuthenticated ? "md:ml-64 md:pt-0 lg:ml-[var(--account-sidebar-width)]" : "md:ml-0 md:pt-16"} ${className}`}
      >
        {children}
      </main>
    </>
  );
}

export default AccountPageShell;
